import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/init.css' // 引入初始化css
import './assets/css/iconfont.css' // 引入iconfont
import './assets/css/animation.css' // 引入动画animation.css


import './plugins/vueCookie.js' // 引入 vue-cookie
import './plugins/element.js' // 引入element
import './plugins/van.js' // 引入van
import axios from './plugins/axios.js'

Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
